import { toast } from "react-toastify";
import axios from "axios";
import settings from "utils/settings";
import defaultErrorHandler from "api/global/default-error-handler";

const { apiUrl } = settings;
const profileUrl = `${apiUrl}profile/`;

export const PROFILE_LOADING = "PROFILE_LOADING";
export const PROFILE_GET_CONTACT_INFO = "PROFILE_GET_CONTACT_INFO";
export const PROFILE_SET_CONTACT_INFO = "PROFILE_SET_CONTACT_INFO";
export const PROFILE_GET_GENERAL_AVAILABILITY = "PROFILE_GET_GENERAL_AVAILABILITY";
export const PROFILE_SET_GENERAL_AVAILABILITY = "PROFILE_SET_GENERAL_AVAILABILITY";
export const PROFILE_GET_TRAVEL_INFO = "PROFILE_GET_TRAVEL_INFO";
export const PROFILE_SET_TRAVEL_INFO = "PROFILE_SET_TRAVEL_INFO";

export const PROFILE_GET_VACATIONS = "PROFILE_GET_VACATIONS";
export const PROFILE_GET_VACATIONS_BY_ID = "PROFILE_GET_VACATIONS_BY_ID";
export const PROFILE_SET_VACATIONS = "PROFILE_SET_VACATIONS";

export const PROFILE_GET_SPECIAL = "PROFILE_GET_SPECIAL";
export const PROFILE_GET_SPECIAL_BY_ID = "PROFILE_GET_SPECIAL_BY_ID";
export const PROFILE_SET_SPECIAL = "PROFILE_SET_SPECIAL";

export const setLoading = (status) => ({
    type: PROFILE_LOADING,
    payload: status
});

export const profileGetContactInfo = () => dispatch => {
    dispatch(setLoading(true));
    axios
        .get(`${profileUrl}contactInfo`)
        .then(response => {
            dispatch({
                type: PROFILE_GET_CONTACT_INFO,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileSetContactInfo = (data) => dispatch => {
    dispatch(setLoading(true));
    axios
        .put(`${profileUrl}contactInfo`, data)
        .then(response => {
            dispatch({
                type: PROFILE_SET_CONTACT_INFO,
                payload: response.data
            });
            toast("Contact Information Successfully Updated", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileSetPassword = (password) => dispatch => {
    dispatch(setLoading(true));
    axios
        .post(`${profileUrl}password`, password)
        .then(() => {
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
            dispatch(setLoading(false));
        });
};

export const profileGetGeneralAvailability = (reset = false) => dispatch => {
    if (reset) {
        dispatch({
            type: PROFILE_GET_GENERAL_AVAILABILITY,
            payload: {}
        });
        return;
    }
    dispatch(setLoading(true));
    axios
        .get(`${profileUrl}generalAvailability`)
        .then(response => {
            dispatch({
                type: PROFILE_GET_GENERAL_AVAILABILITY,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileSetGeneralAvailability = (data) => dispatch => {
    dispatch(setLoading(true));
    axios
        .put(`${profileUrl}generalAvailability`, data)
        .then(response => {
            dispatch({
                type: PROFILE_SET_GENERAL_AVAILABILITY,
                payload: response.data
            });

            toast("General Availability Successfully Updated", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileGetTravelInfo = () => dispatch => {
    dispatch(setLoading(true));
    axios
        .get(`${profileUrl}travelInfo`)
        .then(response => {
            dispatch({
                type: PROFILE_GET_TRAVEL_INFO,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileSetTravelInfo = (data) => dispatch => {
    dispatch(setLoading(true));
    axios
        .put(`${profileUrl}travelInfo`, data)
        .then(response => {
            dispatch({
                type: PROFILE_SET_TRAVEL_INFO,
                payload: response.data
            });
            toast("Travel Preferences Successfully Updated", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileGetVacations = () => dispatch => {
    dispatch(setLoading(true));
    axios.get(`${profileUrl}vacations`)
        .then(response => {
            dispatch({
                type: PROFILE_GET_VACATIONS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileGetVacationsById = (id) => dispatch => {
    if (id === false) {
        dispatch({
            type: PROFILE_GET_VACATIONS_BY_ID,
            payload: {}
        });
        return;
    }
    dispatch(setLoading(true));
    axios.get(`${profileUrl}vacations/${id}`)
        .then(response => {
            dispatch({
                type: PROFILE_GET_VACATIONS_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileCreateVacations = (data, callback) => dispatch => {
    dispatch(setLoading(true));
    axios.post(`${profileUrl}vacations`, data)
        .then(response => {
            dispatch({
                type: PROFILE_SET_VACATIONS,
                payload: response.data
            });

            toast("Vacation Successfully Created", {
                type: toast.TYPE.SUCCESS,
            });
            callback();
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileUpdateVacations = (id, data, callback) => dispatch => {
    dispatch(setLoading(true));
    axios.put(`${profileUrl}vacations/${id}`, data)
        .then(response => {
            dispatch({
                type: PROFILE_SET_VACATIONS,
                payload: response.data
            });
            toast("Vacation successfully Updated", {
                type: toast.TYPE.SUCCESS,
            });
            callback();
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileDeleteVacations = (id) => dispatch => {
    dispatch(setLoading(true));
    axios.delete(`${profileUrl}vacations/${id}`)
        .then(() => {
            dispatch({
                type: PROFILE_SET_VACATIONS,
                payload: id
            });
            toast("Vacation Canceled", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileGetSpecial = () => dispatch => {
    dispatch(setLoading(true));
    axios.get(`${profileUrl}specialAvailability`)
        .then(response => {
            dispatch({
                type: PROFILE_GET_SPECIAL,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileGetSpecialById = (id) => dispatch => {
    if (id === false) {
        dispatch({
            type: PROFILE_GET_SPECIAL_BY_ID,
            payload: {}
        });
        return;
    }
    dispatch(setLoading(true));
    axios.get(`${profileUrl}specialAvailability/${id}`)
        .then(response => {
            dispatch({
                type: PROFILE_GET_SPECIAL_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileCreateSpecial = (data, callback) => dispatch => {
    dispatch(setLoading(true));
    axios.post(`${profileUrl}specialAvailability`, data)
        .then(response => {
            dispatch({
                type: PROFILE_SET_SPECIAL,
                payload: response.data
            });
            callback();
            toast("Special Availability Created Successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileUpdateSpecial = (id, data, callback) => dispatch => {
    dispatch(setLoading(true));
    axios.put(`${profileUrl}specialAvailability/${id}`, data)
        .then(response => {
            dispatch({
                type: PROFILE_SET_SPECIAL,
                payload: response.data
            });
            callback();

            toast("Special Updated Created Successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const profileDeleteSpecial = (id, callback) => dispatch => {
    dispatch(setLoading(true));
    axios.delete(`${profileUrl}specialAvailability/${id}`)
        .then(() => {
            dispatch({
                type: PROFILE_SET_SPECIAL,
                payload: id
            });
            callback();
            toast("Special Availability Removed Successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};
